import React from 'react'

import TablePagination from '@material-ui/core/TablePagination';

import { PAGINATION } from '../../../constants';
import useStyles from './styles';

export default function CustomTablePagination({ children, ...props }) {
  const classes = useStyles();
  const [page, setPage] = React.useState(props.page || 0);
  const [rowsPerPage, setRowsPerPage] = React.useState(props.perPage || PAGINATION.PER_PAGE);

  function componentDidMount() {
    if (props.onChange) {
      props.onChange({ page: parseInt(page) + 1, perPage: rowsPerPage });
    }
  }

  React.useEffect(componentDidMount, [page, rowsPerPage]);

  const handleChangePage = (event, value) => {
    event.preventDefault();
    setPage(value);
  };

  const handleChangeRowsPerPage = (event) => {
    const value = parseInt(event.target.value, 10);
    setRowsPerPage(value);
    setPage(0);
  };

  function getLabelDisplayedRows({ from, to, count }) {
    // console.log({ propsPage: props.page, page, rowsPerPage, from, to, count });
    const lastPage = Math.ceil(count / rowsPerPage) || 1;
    return (<>{from > 0 ? `Exibindo: ${from} a ${to} Total: ${props.count || 0} Página ${props.page + 1} de ${lastPage}` : 'Nenhum resultado encontrado'}</>)
  }

  return (
    <TablePagination
      className={classes.root}
      color="primary"
      component="div"
      count={props.count}
      page={props.page}
      onPageChange={handleChangePage}
      rowsPerPage={rowsPerPage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      labelDisplayedRows={getLabelDisplayedRows}
      backIconButtonText={'Página anterior'}
      labelRowsPerPage={'Linhas por página: '}
      nextIconButtonText={'Próxima página'}
      rowsPerPageOptions={[5, 10, 15, 20, 25, 50, 100, 200]}
      classes={{
        root: classes.tablePagination,
        caption: classes.tablePaginationCaption,
        selectIcon: classes.tablePaginationSelectIcon,
        select: classes.tablePaginationSelect,
        actions: classes.tablePaginationActions,
      }}
    />
  );
}
